import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import Sidebar from './Sidebar';
import ModuleGuard from './ModuleGuard';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  // Detectar si estamos en mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Cerrar sidebar automáticamente en desktop
  useEffect(() => {
    if (!isMobile && sidebarOpen) {
      setSidebarOpen(false);
    }
  }, [isMobile, sidebarOpen]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className={`app-layout ${isHomePage ? 'app-layout--home' : 'app-layout--page'}`}>
      {/* Barra superior con gradiente */}
      <div className="gradient-top-bar" />

      {/* Unico control que ABRE el menu en movil. Sin el, por debajo de 768px
          el sidebar queda fuera de pantalla sin forma de desplegarlo y el
          usuario se queda sin navegacion. Se oculta solo en escritorio (CSS),
          donde el menu ya esta siempre visible. */}
      <button
        type="button"
        className="sidebar-toggle"
        onClick={toggleSidebar}
        aria-label={sidebarOpen ? 'Cerrar menú' : 'Abrir menú'}
        aria-expanded={sidebarOpen}
        aria-controls="sidebar-principal"
      >
        {sidebarOpen ? <FiX /> : <FiMenu />}
      </button>

      <Sidebar isOpen={sidebarOpen} onToggle={closeSidebar} />
      
      <div className="main-content">
        {!isHomePage && <div className="page-gradient-bar" />}
        
        <main className="content-area">
          {/* El guard va aqui dentro para que, si falta el permiso, el usuario
              siga viendo el menu en vez de ser rebotado sin explicacion. */}
          <ModuleGuard>
            <Outlet />
          </ModuleGuard>
        </main>
      </div>
    </div>
  );
};

export default Layout;